import { put, select } from 'redux-saga/effects';
import { getACC1CSVList, getACC1List, getJobIdMarkedAsDeleted } from '../../felles/APICalls_SPRING';
import * as actions from '../actions';
import * as selectors from '../selectors';
import fileDownload from 'js-file-download';
import Utils from '../../felles/Utils';

const normalizeAccountingJobList = (payload: unknown): any[] => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (payload && typeof payload === 'object') {
    const normalizedPayload = payload as { accountingJobList?: unknown; data?: unknown; items?: unknown };

    if (Array.isArray(normalizedPayload.accountingJobList)) {
      return normalizedPayload.accountingJobList;
    }

    if (Array.isArray(normalizedPayload.data)) {
      return normalizedPayload.data;
    }

    if (Array.isArray(normalizedPayload.items)) {
      return normalizedPayload.items;
    }
  }

  return [];
};

//
export function* accountingJobListFetchSaga() {
  try {
    const date = yield select(selectors.date);
    //const user = yield select(selectors.userCred);
    yield put(actions.accountingJobListGetInit());
    const response = yield getACC1List(date);
    const accountingJobList = normalizeAccountingJobList(response.data);
    yield put(actions.accountingJobListGetSuccess(accountingJobList));
  } catch (error) {
    yield put(actions.accountingJobListGetFailed(error));
  }
}

// CSV
export function* accountingJobCSVListFetchSaga() {
  try {
    const date = yield select(selectors.date);
    yield put(actions.accountingJobCVSListGetInit());
    const response = yield getACC1CSVList(date);
    yield fileDownload(response.data, 'jobs_' + Utils.getFormattedDate(date) + '_' + new Date().getTime() + '.csv');
    yield put(actions.accountingJobCVSListGetSuccess());
  } catch (error) {
    yield put(actions.accountingJobCVSListGetFailed(error));
  }
}

//
export function* accoutingJobListDeleteSelected() {
 // const date = yield select(selectors.date);
   const selectedJobList = yield select(selectors.selectedJobList);
  try {
    yield put(actions.accountingJobListSelectedDeletionPostInit());
   /* const response = */yield getJobIdMarkedAsDeleted(selectedJobList);
    yield put(actions.accountingJobListSelectedDeletionPostSuccess());
    //dispatch(actions.accountingDeletionDialogUpdated(false));
  } catch (error) {
    // Fall back - restoring list - assuming there is network connection
    yield put(actions.accountingJobListGet());
    yield put(actions.accountingJobListSelectedDeletionPostFailed());
  }
}

//
export function* accoutingJobListExportSelected() {
  try {
    yield put(actions.accountingJobListSelectedExportGetInit());
    yield put(actions.accountingJobListSelectedExportGetSuccess());
  } catch (error) {
    yield put(actions.accountingJobListSelectedExportGetFailed());
  }
}
